import type { ReactNode } from "react";
import { useLocation } from "react-router-dom";
import { PartsShell } from "../cases/workspace/PartsShell.js";
import { sideOfPath } from "./side.js";
import { WholesaleShell } from "./WholesaleShell.js";

/**
 * The shell for the two pages both sides share — the parts catalog and the
 * stock order report (spec §6.3, §8): the side is read from the address
 * (`/parts/…` is Service, `/wholesale/…` Wholesale — spec §4.1, the URL
 * carries the side), and the page is framed by that side's shell, so
 * opening the catalog from the Wholesale sidebar keeps the wholesale
 * sidebar, its brand line and Wholesale marked current on the switch,
 * exactly as opening it from Service keeps the Parts one. Either shell
 * carries the Parts-only gate and remembers the side and the place.
 */

export interface SidedPageShellProps {
  /** Both sidebars name these two destinations the same way. */
  activeDestination: "catalog" | "stock_order_report";
  className?: string;
  /** Class for the top bar, the sidebar and the scrim (the report keeps them off paper). */
  chromeClassName?: string;
  mainClassName?: string;
  children: ReactNode;
}

export function SidedPageShell({ activeDestination, className, chromeClassName, mainClassName, children }: SidedPageShellProps) {
  const location = useLocation();
  const Shell = sideOfPath(location.pathname) === "wholesale" ? WholesaleShell : PartsShell;
  return (
    <Shell
      page
      activeDestination={activeDestination}
      {...(className !== undefined ? { className } : {})}
      {...(chromeClassName !== undefined ? { chromeClassName } : {})}
      {...(mainClassName !== undefined ? { mainClassName } : {})}
    >
      {children}
    </Shell>
  );
}
